import { CLICK, component, demoFile, feature, HOVER, story } from 'system/demo';

import { TeaserPositionScreen } from '../article/article-teaser-position';

demoFile('open-modules/zdf/feature/teaser-position');

feature('Article - Teaser Positioning Feature', {
    structureKey: 'article',
    state: {
        roles: ['Owner'],
        serverCall: {
            articleTeaserPosition: {
                setArticleTeaserPosition: async () => null,
            },
        },
        language: 'english',
    },
    features: { positionteaser: true },
});

component(
    'Teaser Position Screen',
    TeaserPositionScreen,
    {
        structureKey: 'article',
        instanceKey: 'articleKey',
        state: {
            roles: ['Owner'],
            modulePublic: {
                'article-teaser-position': {
                    articleTeaserPosition: {
                        articleKey: {
                            article_main_text_position_above_second_subheading: {
                                key: 'article_main_text_position_above_second_subheading',
                                value: true,
                                from: 'a',
                                time: 0,
                            },
                        },
                    },
                },
            },
            serverCall: {
                'article-teaser-position': {
                    setArticleTeaserPosition: async () => null,
                },
            },
            language: 'english',
        },
    },
    [
        story('Select another position', [CLICK('article_main_text_position_after_second_paragraph')]),
        story('Unselect the position', [CLICK('article_main_text_position_above_second_subheading')]),
    ],
);

component('Teaser Position Screen', TeaserPositionScreen, {
    structureKey: 'article',
    instanceKey: 'articleKey',
    state: {
        roles: ['Owner'],
        modulePublic: {
            'article-teaser-position': {
                articleTeaserPosition: {
                    articleKey: {
                        article_main_text_position_above_second_subheading: {
                            key: 'article_main_text_position_above_second_subheading',
                            value: true,
                            from: 'a',
                            time: 0,
                        },
                        article_main_text_position_after_last_paragraph: {
                            key: 'article_main_text_position_after_last_paragraph',
                            value: true,
                            from: 'a',
                            time: 0,
                        },
                    },
                },
            },
        },
        serverCall: {
            'article-teaser-position': {
                getArticleTopics: async () => [],
                determineArticleTopics: async () => ['politics'],
            },
        },
        language: 'english',
    },
});
